export default "__VITE_ASSET__DkwaFxIF__"